import { render, staticRenderFns } from "./wikiIndex.vue?vue&type=template&id=1b49eb7f&"
import script from "./wikiIndex.vue?vue&type=script&lang=js&"
export * from "./wikiIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports